import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import Chargers from "../components/Chargers"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "sub-visual.jpg" }) {
      childImageSharp {
        fluid(quality: 70, maxWidth:1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Instrukcja = () => {
    const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | Nasze ładowarki" />
      <Sublinks />

      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-ladowarki`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div
          className="visual-content col-md-8 ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <div className="title text-center">NASZE ŁADOWARKI</div>
          <p className="font-xxl font-light text-center">
            W sieci ORLEN właściciele pojazdów elektrycznych mogą skorzystać
            z&nbsp;ładowarek dostarczonych przez 3&nbsp;różnych producentów:
            Ekoenergetyka, ABB oraz Efacec. <br />
            Obecnie wszystkie modele ładowarek w&nbsp;sieci ORLEN są
            wyposażone w&nbsp;3&nbsp;różne rodzaje złącz: dwa złącza DC (CCS
            i&nbsp;CHAdeMO) oraz jedno AC (Typ 2). Większość naszych ładowarek
            znajduje się przy stacjach paliw ORLEN.
          </p>
        </div>
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
      </BackgroundImage>
      <Chargers />
    </Layout>
  )
}
export default Instrukcja



